import { buildBinderListings } from '@monofe/di';
import api from './api';
import asset from './asset';
import cache from './cache';
import log from './log';
import manifest from './manifest';
export default buildBinderListings([api, asset, cache, log, manifest]);